import { Guid } from '../guid';

export class CsvColumnProps {
	id = Guid();
	columnIndex?: number;
	columnLabel: string = '';

	constructor(init?: Partial<CsvColumnProps>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
